<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-clipboard-list" texto-titulo="Editar marca"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarMarca()">
          <float-label label="Descripcion:" clase>
            <input
              v-model="marca.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="(enviado && !$v.marca.descripcion.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.marca.descripcion.required"
              >Debe ingresar una descripción</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Marca from "@/models/marca";
export default {
  name: "NuevaMarca",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel
  },
  data() {
    return {
      marca: new Marca(null, ""),
      loading: false,
      enviado: false
    };
  },
  validations: {
    marca: {
      descripcion: { required }
    }
  },
  mounted() {
    this.marca.id = this.$route.params.id;
    this.getMarca();
  },
  methods: {
    getMarca() {
      this.loading = true;
      axios
        .get("marcas/" + this.marca.id)
        .then(res => {
          if (res.data.success) {
            this.marca = res.data.marca;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado marca.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarMarca() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/marcas/" + this.marca.id, this.marca)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.marca.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarMarcas" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>